import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const ResetIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M9 17.2066C13.5324 17.2066 17.2066 13.5324 17.2066 8.99999C17.2066 4.46762 13.5324 0.793397 9.00001 0.793397C4.46763 0.793396 0.793408 4.46761 0.793408 8.99999C0.793408 11.3516 1.78251 13.4722 3.36739 14.9684M3.70274 11.6112L3.70274 15.1415L0.280801 15.1415" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

ResetIcon.displayName = 'ResetIcon';
